import { Card, CardContent } from "@/components/ui/card";
import { GraduationCap, TrendingUp, Gamepad2, Star } from "lucide-react";
import { motion } from "framer-motion";

interface Props {
  childExams: any[];
  childGames: any[];
}

export default function ParentChildStats({ childExams, childGames }: Props) {
  const examAvg = childExams.length > 0
    ? Math.round(childExams.reduce((sum: number, e: any) => sum + (e.percentage || 0), 0) / childExams.length)
    : 0;
  const gameAvg = childGames.length > 0
    ? Math.round(childGames.reduce((sum: number, g: any) => sum + (g.percentage || 0), 0) / childGames.length)
    : 0;

  const stats = [
    { label: "الامتحانات", value: childExams.length, icon: GraduationCap, color: "text-primary" },
    { label: "معدل الامتحانات", value: `${examAvg}%`, icon: TrendingUp, color: "text-primary" },
    { label: "الألعاب التعليمية", value: childGames.length, icon: Gamepad2, color: "text-primary" },
    { label: "معدل الألعاب", value: `${gameAvg}%`, icon: Star, color: "text-amber-500" },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {stats.map((s, i) => (
        <motion.div key={i} initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: i * 0.06 }}>
          <Card className="shadow-card">
            <CardContent className="p-4 flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center shrink-0">
                <s.icon className={`w-5 h-5 ${s.color}`} />
              </div>
              <div>
                <div className="text-xl font-bold text-foreground">{s.value}</div>
                <div className="text-xs text-muted-foreground">{s.label}</div>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      ))}
    </div>
  );
}
